<template>
  <div class="poster">
    <div class="poster-div" v-if="`${userInfo.memberType}` === '1' && signBool && `${type}` === '2'">
      <div class="sim-textarea">
        <van-field class="textarea" type="textarea" v-model="signContent" placeholder="请填写本次参加活动名称" rows="6" autosize
          maxlength="500" show-word-limit />
      </div>
      <div class="tip-div">
        <img src="@/assets/images/simulator/img(23).png" class="icon-tip" alt="">
        <span class="tip-txt">请填写本次参加活动名称</span>
      </div>
      <div class="submit-btn" @click="handleSign">签到并提交</div>
    </div>
<!--    <div class="poster-content" v-else>-->
<!--      <img :src="imgSrc" class="poster-img" alt="">-->
<!--    </div>-->
  </div>
</template>
<script>
import { getSimulators, getRemindBool, postSimulatorSign } from '@/api/simulator'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data () {
    return {
      // imgSrc: '',
      signContent: '',
      signBool: true,
      type: '1',
      simulatorStatus: 1
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  async mounted () {
    if (`${this.userInfo.memberType}` !== '1') {
      const res = await getRemindBool({ userId: this.userInfo.id, readType: 'SimulatorEmpower' })
      if (!res.data && `${this.userInfo.memberType}` !== '1') {
        this.$router.replace({ path: '/simulator/page', query: { simulatorId: this.$route.query.simulatorId } })
      } else {
        await this.handleGetSimulator()
      }
    } else {
      await this.handleGetSimulator()
    }
  },
  methods: {
    async handleSign () {
      const {sharetimes, sourceShare, entrance} = this.$route.query
      if (sharetimes || sourceShare || entrance) {
        this.$toast('请通过扫描模拟器二维码进行签到操作！')
        return
      }
      if (`${this.simulatorStatus}` === '2') return
      let params = {
        'simulatorId': this.$route.query.simulatorId,
        'userId': this.userInfo.id
      }
      if (this.signContent) {
        params.content = this.signContent
      }
      if (!this.$route.query.simulatorId) return
      await postSimulatorSign(params)
      this.$toast('签到成功')
      setTimeout(() => {
        if (`${this.type}` === '1') {
          const courseCategoryIdFirst = '1935545825602424833'
          const courseCategoryIdSecond = '1935545953646137345'
          this.$router.replace({
            path: '/database',
            query: {
              courseCategoryIdFirst,
              courseCategoryIdSecond
            }
          })
        }
        if (`${this.type}` === '2') {
          this.$router.replace({
            path: '/home'
          })
        }
      }, 2000)
      this.signBool = false
    },
    // @ApiModelProperty(value ="类型(1:模拟器二维码;2:会议场所码;)")
    async handleGetSimulator () {
      const res = await getSimulators({ simulatorId: this.$route.query.simulatorId })
      this.type = res.data.type
      this.simulatorStatus = res.data.simulatorStatus
      if (`${res.data.simulatorStatus}` === '2') {
        const txt = `${this.type}` === '1' ? '该模拟器二维码已停用！请联系管理员。' : '该会议场所码已停用！请联系管理员。'
        this.$toast(txt)
        return
      }
      if (`${this.userInfo.memberType}` !== '1' && `${this.type}` === '2') {
        await this.handleSign()
        return
      }
      if (`${this.type}` === '1') {
        await this.handleSign()
        // this.imgSrc = res.data.poster ? res.data.poster.url : ''
      }
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.poster {
  background: #F9F8F7;
  min-height: 100vh;
}

.poster-img {
  width: 100%;
  display: block;
}

.sim-textarea {
  width: 100%;
  padding: 16px 10px;
  box-sizing: border-box;

  .textarea {
    border-radius: 8px;
    color: #949BA5;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-size: 14px;
  }
}

.tip-div {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 26px;
  height: 20px;

  .icon-tip {
    width: 14px;
    height: 14px;
    margin-right: 6px;
  }

  .tip-txt {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
  }
}

.submit-btn {
  width: calc(100% - 40px);
  margin-left: 20px;
  background: #EB1700;
  border-radius: 100px;
  box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
  text-align: center;
  height: 42px;
  line-height: 42px;
  margin-top: 8px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/views/simulator/poster.vue